<template>
 <div id="preventPollution" class="page-content">
   <el-dialog title="导入结果说明" :visible.sync="modalInfo.isShow" width="960px">
     <div style="height: 574px;overflow: auto;">
       <div class="prompt" style="margin-top: 5px;margin-bottom: 8px;width: calc(100% - 40px);margin-left: 20px;margin-right: 20px;">
         <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
         <span class="promptFont">{{modalInfo.reminder}}</span>
       </div>
       <!-- 表格 -->
        <el-table
        header-row-class-name="data-table-header"
        ref="dataTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: calc(100% - 40px);margin-left: 20px;margin-right: 20px;"
        :header-cell-class-name='must'
      >
        <el-table-column
          v-for="(colItem,i) in columsData"
          :key="i"
  		    :prop="colItem.prop"
          :label="colItem.label"
          min-width="120"
          :width="colItem.width?colItem.width:'auto'"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top-start">
              <div slot="content">{{scope.row[colItem.prop]}}</div>
              <span :title="scope.row[colItem.prop]"
                style="overflow: hidden;
                white-space: nowrap;
                display:block;
                text-overflow: ellipsis;">
                {{scope.row[colItem.prop]}}
              </span>
            </el-tooltip>

          </template>
        </el-table-column>
        <!-- 错误说明列 -->
        <el-table-column label="错误说明" fixed="right" width="200">
          <template slot-scope="scope">
            <span style="color: red;">
              {{scope.row.err_info}}
            </span>
          </template>
        </el-table-column>
      </el-table>
     </div>
     <div slot="footer" class="dialog-footer">
       <el-button @click="modalInfo.isShow = false" size="small" type="TheCustom" style="margin-top: 30px;">我知道了</el-button>
     </div>
   </el-dialog>
 </div>
</template>
<script>
 export default {
   name: "importErrorResult",
   props:{
     modalInfo:{
      type:Object
     },
     tableData:{
      type:Array
     },
     columsData:{
       type:Array
     }
   },
   data() {
     return {}
   },
   methods: {
     must(obj){
  		 if (
        obj.column.label == '平台'
        || obj.column.label == '旺旺'
        || obj.column.label == '店铺名称'
        || obj.column.label == '经销商名称'
        || obj.column.label == '经销商名称'
        || obj.column.width == '321'
      ) {
  			 return 'must';
  		 }
  	 },
   }
 }
</script>
<style scoped lang="scss">
 .prompt {
   height: 28px;
   border: 1px solid #108cee;
   background-color: #e6f7ff;
   border-radius: 5px;
   line-height: 28px;
   margin-bottom: 5px;
 }
 .promptFont{
   color: #108cee;
   font-size: 14px;
   margin-left: 3px;
   margin-right: 3px;
 }
 .el-button--TheCustom {
   color: #666;
   border-color: #D9D9D9;
   background-color: #fff;
 }
 .el-button--TheCustom:hover  {
   color: #666;
   border-color: #ded2b8;
   background-color: #faf9f5;
 }
</style>
<style lang="scss">
#preventPollution {
  .el-table th.must>.cell:before {
  	content: '*';
  	color: #ff1818;
  }
  // .el-dialog__title {
  //   font-size: 16px;
  //   font-weight: 600;
  // }
 .el-table__empty-text{
   padding-top: 100px;
   // background: url("../../../assets/img/other/nodata.svg") no-repeat;
   background-position: center 66px;
 }
 .el-table th {
   background-color: #f3f7ff !important;
 }
 #dialog {
   .el-dialog__header {
     padding: 20px 20px 10px;
     border-bottom: 1px solid #d9d9d9;
   }
   .el-button--primary {
     color: #FFF;
     background-color: #bda571;
     border-color: #bda571;
   }
   .el-button--primary:hover {
     color: #FFF;
     background-color: #c0ae8a;
     border-color: #c0ae8a;
   }
 }
 .el-button+.el-button {
   margin-left: 1px;
 }
 .el-table thead {
   color: #333333;
   font-weight: 500;
 }
}
</style>
